export * from './delete-template.service';
export * from './delete-template.service.module';